const publicUrl = process.env.PUBLIC_URL || "";
const baseUrl = publicUrl.replace(/\/$/, "");
const serviceWorkerVersion = "20260922-01";

function appBase(path) {
  return `${baseUrl}${path}`;
}

function registerWorker(scriptPath, scopePath, label) {
  const versionedScriptPath = `${scriptPath}?v=${serviceWorkerVersion}`;

  return navigator.serviceWorker
    .register(appBase(versionedScriptPath), { scope: appBase(scopePath) || "/" })
    .then(() => {
      console.log(`${label} PWA service worker registered`);
    })
    .catch(error => {
      console.error(`${label} PWA service worker registration failed:`, error);
    });
}

export function register() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    registerWorker("/service-worker-scanner.js", "/", "Scanner");
    registerWorker("/service-worker-admin.js", "/admin/", "Admin");
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}
